import { IFilterControl } from "../../models/report-interface";
import { Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "inputFilter",
     template: `
                <div class="ui icon input">
                    <input [attr.id]="filterControl.name" type="{{ filterControl.type === 'NumberFilter' ? 'number': 'text' }}" [(ngModel)]="filterControl.selectedData">
                    <i *ngIf="icon" class="search icon"></i>
                </div>
                <label>{{filterControl.title}}</label>
    `,
})

export class FilterControlTextComponent {
    @Input() public filterControl: IFilterControl;
    @Input() public icon: boolean;
    @Output() public refFilterApply: EventEmitter<any> = new EventEmitter();

    public FilterApply(item) {
        this.filterControl.activate(item);
        this.refFilterApply.emit(this.filterControl);
    }
}



// WEBPACK FOOTER //
// ./client/app/shared/reportControls/filter-control-text-component.ts